/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetVatCodesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetVatCodesQuery = {
  __typename?: 'Query',
  vatCodes?: Array<{
    __typename?: 'VATCode',
    id: number,
    code: number,
    description: string,
    label?: string | null,
    percentage: number,
    type: Types.VatCodeType,
    transactionType: Types.TransactionType,
    allocation: Types.VatRelation,
    isDefault: boolean
  }> | null
};

export type GetVatCodeQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetVatCodeQuery = {
  __typename?: 'Query',
  vatCode?: {
    __typename?: 'VATCode',
    id: number,
    code: number,
    description: string,
    label?: string | null,
    percentage: number,
    type: Types.VatCodeType,
    transactionType: Types.TransactionType,
    allocation: Types.VatRelation,
    isDefault: boolean
  } | null
};

export type GetVatCodesForSelectQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetVatCodesForSelectQuery = {
  __typename?: 'Query',
  vatCodes?: Array<{
    __typename?: 'VATCode',
    id: number,
    label?: string | null,
    allocation: Types.VatRelation,
    percentage: number
  }> | null
};


export const GetVatCodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVatCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vatCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"vatCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"vatCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VATCode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"allocation"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]} as unknown as DocumentNode<GetVatCodesQuery, GetVatCodesQueryVariables>;
export const GetVatCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVatCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vatCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"vatCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"vatCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VATCode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"allocation"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]} as unknown as DocumentNode<GetVatCodeQuery, GetVatCodeQueryVariables>;
export const GetVatCodesForSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVatCodesForSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vatCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"allocation"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}}]} as unknown as DocumentNode<GetVatCodesForSelectQuery, GetVatCodesForSelectQueryVariables>;